import user from './user';
import menu from './menu';
import oauth from './oauth';
import param from './param';
import wel from './wel';
import desk from './desk';
import console from './console';
import statistical from './statistical';


/**
 * 模拟数据mock
 *
 * mock是否开启模拟数据拦截
 */

const options = {mock: true};

user(options);

menu(options);

oauth(options);

param(options);
// 首页Mock接口
wel(options);
// 工作站Mock接口
desk(options);
// 监控台Mock接口
console(options);
// 统计分析
statistical(options);
